/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Case,
    CaseFromJSON,
    CaseToJSON,
} from '../models';

export interface GetCaseRequest {
    id: number;
}

export interface GetCasesByFileMarkRequest {
    fileMark: Array<string>;
    ordering?: string;
}

/**
 * IsirApi - interface
 * 
 * @export
 * @interface IsirApiInterface
 */
export interface IsirApiInterface {
    /**
     * Return case based on primary key.
     * @param {number} id A unique integer value identifying this case.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IsirApiInterface
     */
    getCaseRaw(requestParameters: GetCaseRequest): Promise<runtime.ApiResponse<Case>>;

    /**
     * Return case based on primary key.
     */
    getCase(requestParameters: GetCaseRequest): Promise<Case>;

    /**
     * Return cases based on file mark
     * @param {Array<string>} fileMark 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IsirApiInterface
     */
    getCasesByFileMarkRaw(requestParameters: GetCasesByFileMarkRequest): Promise<runtime.ApiResponse<Array<Case>>>;

    /**
     * Return cases based on file mark
     */
    getCasesByFileMark(requestParameters: GetCasesByFileMarkRequest): Promise<Array<Case>>;

}

/**
 * 
 */
export class IsirApi extends runtime.BaseAPI implements IsirApiInterface {

    /**
     * Return case based on primary key.
     */
    async getCaseRaw(requestParameters: GetCaseRequest): Promise<runtime.ApiResponse<Case>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getCase.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/isir/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseFromJSON(jsonValue));
    }

    /**
     * Return case based on primary key.
     */
    async getCase(requestParameters: GetCaseRequest): Promise<Case> {
        const response = await this.getCaseRaw(requestParameters);
        return await response.value();
    }

    /**
     * Return cases based on file mark
     */
    async getCasesByFileMarkRaw(requestParameters: GetCasesByFileMarkRequest): Promise<runtime.ApiResponse<Array<Case>>> {
        if (requestParameters.fileMark === null || requestParameters.fileMark === undefined) {
            throw new runtime.RequiredError('fileMark','Required parameter requestParameters.fileMark was null or undefined when calling getCasesByFileMark.');
        }

        const queryParameters: any = {};

        if (requestParameters.fileMark) {
            queryParameters['file_mark'] = requestParameters.fileMark;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/isir/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CaseFromJSON));
    }

    /**
     * Return cases based on file mark
     */
    async getCasesByFileMark(requestParameters: GetCasesByFileMarkRequest): Promise<Array<Case>> {
        const response = await this.getCasesByFileMarkRaw(requestParameters);
        return await response.value();
    }

}
